import React from "react";

export type BadgeVariant =
  | "success"
  | "danger"
  | "warning"
  | "info"
  | "neutral";
export type BadgeSize = "xs" | "sm" | "md" | "lg" | "xl";

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
  className?: string;
}

/**
 * Reusable Badge component with industry-standard sizes.
 * Defaults: variant="neutral", size="sm"
 * See BADGE_GUIDE.md for examples and usage patterns.
 */
const Badge: React.FC<BadgeProps> = ({
  children,
  variant = "neutral",
  size = "sm",
  className = "",
}) => {
  return (
    <span className={`status-badge ${size} ${variant} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;
